var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{attrs:{"config":_vm.options,"placeholder":_vm.placeholder},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }